import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

@Component({
    selector: 'sam4-first-page-layout',
    templateUrl: './first-page-layout.component.html',
    styleUrls: ['./first-page-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FirstPageLayoutComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
